import { render, staticRenderFns } from "./ExpertRedirectView.vue?vue&type=template&id=555f315d&scoped=true"
import script from "./ExpertRedirectView.vue?vue&type=script&lang=js"
export * from "./ExpertRedirectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f315d",
  null
  
)

export default component.exports